import React from "react";
import Header from "./Header";
import PqrsdAdminList from "../pqrsd/PqrsdAdminList";

export default function LayoutPqrsdGroup() {
  return (
    <>
      <Header />
      <PqrsdAdminList scope="group" />
    </>
  );
}
